import { render, staticRenderFns } from "./BuscaGeral.vue?vue&type=template&id=52e199a2"
import script from "./BuscaGeral.vue?vue&type=script&lang=js"
export * from "./BuscaGeral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports